/* Welaza: block checkout while the goods total is below the minimum order.
   Emirates listed in C.exempt (Dubai by default) have no minimum; the emirate comes
   from the picker in the cart drawer. With no emirate chosen yet only a hint is shown. */
(() => {
  const C = window.wzMinOrder;
  if (!C || window.__wzMinBound) return;
  window.__wzMinBound = true;

  const BTN = 'button[name="checkout"], input[name="checkout"], a[href$="/checkout"]';
  const EXPRESS = '.additional-checkout-buttons, shopify-accelerated-checkout-cart';
  let total = Number(C.total) || 0;

  const sep = (v, d, th, dec) => {
    const p = v.toFixed(d).split('.');
    p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
    return p.join(dec);
  };
  const money = (cents) => {
    const v = cents / 100;
    const map = {
      amount: sep(v, 2, ',', '.'),
      amount_no_decimals: sep(v, 0, ',', '.'),
      amount_with_comma_separator: sep(v, 2, '.', ','),
      amount_no_decimals_with_comma_separator: sep(v, 0, '.', ','),
      amount_with_apostrophe_separator: sep(v, 2, "'", '.'),
      amount_with_space_separator: sep(v, 2, ' ', ','),
      amount_no_decimals_with_space_separator: sep(v, 0, ' ', ',')
    };
    return (C.moneyFormat || '{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => map[k] || map.amount);
  };
  const exempt = (C.exempt || []).map((z) => String(z).trim().toUpperCase()).filter(Boolean);
  const chosenZone = () => { try { return localStorage.getItem('wz_zone'); } catch (e) { return null; } };
  // 'block' | 'hint' | 'none'
  const mode = () => {
    if (!(total > 0 && total < C.min)) return 'none';
    const zone = chosenZone();
    if (!zone) return exempt.length ? 'hint' : 'block';
    return exempt.includes(zone) ? 'none' : 'block';
  };
  const isBelow = () => mode() === 'block';

  const apply = () => {
    const m = mode();
    const below = m === 'block';
    const fill = (t) => t.replace('[min]', `<strong>${C.minText}</strong>`).replace('[amount]', `<strong>${money(C.min - total)}</strong>`);
    const html = m === 'block' ? fill(C.msg) : m === 'hint' ? fill(C.hint || C.msg) : '';
    document.querySelectorAll(BTN).forEach((b) => {
      if (below) {
        if (!b.hasAttribute('disabled')) b.setAttribute('disabled', '');
        if (!b.classList.contains('wz-min-off')) b.classList.add('wz-min-off');
        b.setAttribute('aria-disabled', 'true');
      } else if (b.classList.contains('wz-min-off')) {
        b.removeAttribute('disabled');
        b.removeAttribute('aria-disabled');
        b.classList.remove('wz-min-off');
      }
      let note = b.previousElementSibling;
      const has = note && note.classList.contains('wz-min-note');
      if (html) {
        if (!has) {
          note = document.createElement('p');
          note.setAttribute('role', 'status');
          b.before(note);
        }
        const cls = m === 'hint' ? 'wz-min-note is-hint' : 'wz-min-note';
        if (note.className.replace(' is-shake', '') !== cls) note.className = cls;
        if (note.innerHTML !== html) note.innerHTML = html;
      } else if (has) {
        note.remove();
      }
    });
    document.querySelectorAll(EXPRESS).forEach((el) => {
      if (el.classList.contains('wz-min-hide') !== below) el.classList.toggle('wz-min-hide', below);
    });
  };

  const nativeFetch = window.fetch.bind(window);
  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  let timer;
  const refresh = () => {
    clearTimeout(timer);
    timer = setTimeout(async () => {
      try {
        const cart = await nativeFetch(`${root()}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
        total = cart.items.reduce((s, i) => s + (C.protectId && i.variant_id == C.protectId ? 0 : i.final_line_price), 0);
        apply();
      } catch (e) { console.error('[wz-min-order]', e); }
    }, 150);
  };

  // re-check after any cart change made with fetch (theme, upsell, apps)
  window.fetch = function (input, init) {
    const p = nativeFetch(input, init);
    try {
      const url = String((input && input.url) || input);
      if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(refresh, () => {});
    } catch (e) {}
    return p;
  };
  ['cart:update', 'cart:reload', 'cart:drawer:render', 'cart:refresh'].forEach((ev) => document.addEventListener(ev, refresh));
  document.addEventListener('wz:zone', apply);

  // keep the state after the theme re-renders the drawer or the cart page
  let raf;
  new MutationObserver(() => {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(apply);
  }).observe(document.documentElement, { childList: true, subtree: true });

  // last line of defence: stop clicks and submits to checkout
  const stop = (e, btn) => {
    e.preventDefault();
    e.stopImmediatePropagation();
    const note = btn && btn.previousElementSibling;
    if (note && note.classList.contains('wz-min-note')) {
      note.classList.remove('is-shake');
      void note.offsetWidth;
      note.classList.add('is-shake');
    }
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest && e.target.closest(BTN);
    if (b && isBelow()) stop(e, b);
  }, true);
  document.addEventListener('submit', (e) => {
    const s = e.submitter;
    if (s && s.name === 'checkout' && isBelow()) stop(e, s);
  }, true);

  apply();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
})();
